import { candidateFileTypePost } from "#candidate/services/api"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Box, TextField } from "@mui/material"
import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormGroup from "@mui/material/FormGroup"
import { useCallback, useState } from "react"
import { toast } from "react-toastify"

const initialValues = {
	name: "",
	is_required: false,
	is_confidential: false,
}
export default function CandidateFileTypeForm({ values, setValues }) {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
			<TextField
				label="Nombre del tipo de archivo"
				value={values.name}
				onChange={(e) => setValues({ ...values, name: e.target.value.toUpperCase() })}
			/>
			<FormGroup>
				<FormControlLabel
					control={<Checkbox />}
					label="Es Obligatorio"
					value={values.is_required}
					onChange={() => setValues({ ...values, is_required: !values.is_required })}
				/>
				<FormControlLabel
					control={<Checkbox />}
					label="Es Privado"
					value={values?.is_confidential}
					onChange={() =>
						setValues({ ...values, is_confidential: !values.is_confidential })
					}
				/>
			</FormGroup>
		</Box>
	)
}

export const CandidateFileTypeFormDialog = ({ open, setOpen, refresh }) => {
	const [values, setValues] = useState(initialValues)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		if (typeof refresh === "function") refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateFileTypePost, { end, success })

	const handleSubmit = useCallback(() => {
		if (!values.name) {
			toast.error("El nombre es obligatorio")
			return
		}
		setDisabled(true)
		fetch(values)
	}, [fetch, values])

	const handleClose = useCallback(() => {
		setOpen(false)
		setDisabled(false)
		setValues(initialValues)
	}, [setOpen, setDisabled])

	return (
		<DialogMaster
			{...{
				title: "Agregar archivo al candidato",
				setOpen,
				open,
				handleSubmit,
				disabled,
				onClose: handleClose,
			}}
		>
			<CandidateFileTypeForm {...{ values, setValues }} />
		</DialogMaster>
	)
}
